var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeHeader'),_c('Regions'),_c('Footer'),_c('div',{staticClass:"stepper-popup",attrs:{"id":"stepper-popup"}},[_c('div',{staticClass:"stepper-popup__content"},[_c('a',{staticClass:"stepper-popup__close",attrs:{"href":"#section-regions"},on:{"click":_vm.resetStepper}},[_vm._v("×")]),_c('Stepper',{ref:"stepper"})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }